<template>
  <div v-if="visible" :class="['notification', type]">
    <p>{{ message }}</p>
  </div>
</template>

<script>
export default {
  props: {
    message: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      default: 'error', // Por defecto, la notificación es de tipo error.
    },
    duration: {
      type: Number,
      default: 3000, // Duración de la notificación en milisegundos.
    },
  },
  data() {
    return {
      visible: true,
    };
  },
  mounted() {
    setTimeout(() => {
      this.visible = false;
    }, this.duration);
  },
};
</script>

<style scoped>
.notification {
  position: fixed;
  top: 20px;
  right: 20px;
  padding: 10px 20px;
  border-radius: 5px;
  color: #fff;
  z-index: 1000;
  transition: opacity 0.3s ease;
}
.notification.error {
  background-color: #ff4d4d;
}
.notification.warning {
  background-color: #ffcc00;
}
</style>
